// extracted by mini-css-extract-plugin
export var downArrow = "_ag-0";
export var label = "_ag-1";
export var treatmentCard = "_ag-3";
export var upArrow = "_ag-2";